// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1_Obt","cls2":"RemovedItemNotice-cls2_nIc RemovedItemNotice-cls1_Obt"};